<template>
  <div>
    <form @keyup.enter="save()" ref="connectedPipeline" class="pipeline-form">
      <custom-input
        required
        inputType="text"
        placeholder="Название"
        labelText="Название"
        v-model="model.name"
        :errorMessage="model.validator['name']"
        :inputValue="model.name"
        name="name"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Внутренний радиус, м"
        labelText="Внутренний радиус, м"
        v-model="model.R"
        :errorMessage="model.validator['R']"
        :inputValue="model.R"
        name="R"
      />

      <div class="input-groupe">
        <custom-input
          required
          inputType="number"
          placeholder="Длина, м"
          labelText="Длина, м"
          v-model="model.L"
          :errorMessage="model.validator['L']"
          :inputValue="model.L"
          name="L"
          id="L"
          tooltipValue="Вы можете ввести длину трубопровода вручную или выбрать автоматический расчет, что бы программа сама определила длину"
          :disabled="Boolean(model.autoL)"
        />
        <custom-checkbox
          class="form-checkbox"
          :value="Boolean(model.autoL)"
          @input="handleCheckboxChange"
          labelText="Автоматический расчет"
        />
      </div>

      <custom-input
        required
        inputType="number"
        placeholder="Давление, кПа"
        labelText="Давление, кПа"
        v-model="model.P"
        :errorMessage="model.validator['P']"
        :inputValue="model.P"
        name="P"
      />

      <custom-input
        required
        inputType="number"
        placeholder="Время аварийного отключения, с"
        labelText="Время аварийного отключения, с"
        v-model="model.shutdown"
        :errorMessage="model.validator['shutdown']"
        :inputValue="model.shutdown"
        name="shutdown"
      />

      <main-select
        class="select-item"
        label="Система пожаротушения"
        id="extinguish-system"
        v-model="model.extinguish_system"
        :options="extinguishOptions"
        placeholder="Система пожаротушения"
        :clearable="false"
        isRequired
        :errorMessage="model.validator['extinguish_system']"
        :searchable="false"
        withReduce
      />

      <main-select
        class="select-item"
        label="Система сигнализации"
        id="alarm-system"
        v-model="model.alarm_system"
        :options="alarmOptions"
        placeholder="Система пожаротушения"
        :clearable="false"
        isRequired
        :errorMessage="model.validator['alarm_system']"
        :searchable="false"
        withReduce
      />

      <custom-input
        required
        inputType="number"
        placeholder="Коэффициент разлития"
        labelText="Коэффициент разлития"
        v-model="model.f"
        :errorMessage="model.validator['f']"
        :inputValue="model.f"
        :tooltipValue="spillageCoefficient"
        name="f"
      />

      <custom-checkbox @input="handleUndergroundChange" :value="Boolean(model.underground)" labelText="Подземный" />
    </form>

    <div class="modal-footer-buttons">
      <main-button :loading="saving" type="button" @click="save()">
        <span v-if="newPipeline && newPipeline.id">Сохранить</span><span v-else>Присоединить</span>
      </main-button>

      <main-button color="link" type="button" @click="$emit('onCancelClick')">Отмена</main-button>
    </div>
  </div>
</template>

<script>
import { baseMethods } from "../pipelines/baseMethods";
import CustomInput from "../../../components/ui/Input.vue";
import CustomCheckbox from "../../../components/ui/Checkbox.vue";
import { EXTINGUISH_OPTIONS, SPILLAGE_COEFFICIENT } from "../../../constants/constants";
import MainSelect from "../../../components/ui/MainSelect.vue";
import MainButton from "../../../components/ui/MainButton.vue";
import { scrollToErrorInput } from "../../../utils/utils";

export default {
  name: "PumpLiquid",
  components: { CustomInput, CustomCheckbox, MainSelect, MainButton },
  props: {
    proj_id: [Number, String],
    obj_id: Number,
    newPipeline: Object,
    installations: Array,
    substrate: Object,
    showError: Function,
  },
  mixins: [baseMethods],
  watch: {
    "model.autoL"() {
      if (this.model.autoL == 1) {
        let dots = [{ x: this.newPipeline.parentDots.x, y: this.newPipeline.parentDots.y }].concat(
          this.newPipeline.dots
        );
        this.model.L = this.getPipelineLength(dots, this.substrate.k);
      }
    },
  },
  mounted() {
    if (this.newPipeline) {
      Object.assign(this.model, this.newPipeline);
      if (this.model.autoL == 1) {
        let dots = [{ x: this.newPipeline.parentDots.x, y: this.newPipeline.parentDots.y }].concat(
          this.newPipeline.dots
        );
        this.model.L = this.getPipelineLength(dots, this.substrate.k);
      }
      this.model.alarm_system = Number(this.model.alarm_system);
      this.model.extinguish_system = Number(this.model.extinguish_system);
    }
  },
  data() {
    return {
      saving: false,
      extinguishOptions: EXTINGUISH_OPTIONS,
      alarmOptions: [
        { code: 0, label: "Отсутствует" },
        { code: 0.8, label: "Присутствует" },
      ],
      spillageCoefficient: SPILLAGE_COEFFICIENT,
      model: {
        name: "Технологический трубопровод",
        L: 1,
        R: 0.1,
        P: null,
        shutdown: 0,
        extinguish_system: 0,
        alarm_system: 0,
        f: 150,
        autoL: 1,
        underground: 0,
        validator: {},
      },
    };
  },
  methods: {
    handleUndergroundChange() {
      this.model.underground ? (this.model.underground = 0) : (this.model.underground = 1);
    },

    validate() {
      this.model.validator = {};
      const errors = {};
      let isValid = true;
      const elementNames = [
        ...Array.from(this.$refs.connectedPipeline.elements)
          .map((element) => element.name)
          .filter((item) => Boolean(item)),
      ];
      elementNames.forEach((item) => {
        if (this.model[item] !== 0 && this.model[item] !== "0" && !this.model[item]) {
          isValid = false;
          errors[item] = "Необходимо заполнить поле";
        }
      });
      scrollToErrorInput(errors, this.$refs.connectedPipeline);
      this.model.validator = errors;
      return isValid;
    },

    save() {
      if (!this.validate()) return;
      this.saving = true;
      if (!this.newPipeline.id) {
        this.newPipeline.dots.shift();
        this.$http
          .post("risk/pipeline/create?proj_id=" + this.proj_id, Object.assign(this.newPipeline, this.model))
          .then((response) => {
            if (
              !this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].pipelines
            ) {
              this.$set(
                this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index],
                "pipelines",
                []
              );
            }
            this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].pipelines.push(
              response.data
            );
            this.$emit("update:newPipeline", {});
            this.$emit("update:action", "default");
            this.$emit("pipelineWindowClose");
          })
          .catch((e) => {
            if (e.response.data) {
              // Бекенд на 400 статус не отдает внятной ошибки, придется выводить общее сообщение

              if (
                !this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].pipelines
              ) {
                this.$set(
                  this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index],
                  "pipelines",
                  []
                );
              }
              this.installations[this.newPipeline.obj_index].mapObjects[
                this.newPipeline.map_object_index
              ].pipelines.push({ ...e.response.data, dots: JSON.parse(e.response.data.dots) });
              this.$emit("update:newPipeline", {});
              this.$emit("update:action", "default");
              this.$emit("pipelineWindowClose");

              const id = e.response.data.id;
              this.$set(this.model, "validator", e.response.data.errors);
              if (e.response.data.errors.substance) {
                this.showError(e.response.data.errors.substance);
              }
            }
          })
          .finally(() => {
            this.saving = false;
          });
      } else {
        if (this.model.substance && this.model.substance.id) {
          this.model.substance = this.model.substance.id;
        } else {
          this.model.substance = null;
        }
        delete this.model.dots;
        this.$http
          .post("risk/objects/update?proj_id=" + this.proj_id + "&id=" + this.newPipeline.id, this.model)
          .then((response) => {
            this.$set(
              this.installations[this.newPipeline.obj_index].mapObjects[this.newPipeline.map_object_index].pipelines,
              this.newPipeline.pipe_index,
              response.data
            );
            this.$emit("pipelineWindowClose");
          })
          .catch((e) => {
            if (e.response.data) {
              this.$set(this.model, "validator", e.response.data);
            }
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },

    handleCheckboxChange() {
      this.model.autoL = this.model.autoL == 1 ? 0 : 1;
      if (this.model.autoL == 1) {
        let dots = [
          {
            x: this.newPipeline.parentDots.x,
            y: this.newPipeline.parentDots.y,
          },
        ].concat(this.newPipeline.dots);
        this.model.L = this.getPipelineLength(dots, this.substrate.k);
      }
    },
  },
};
</script>

<style scoped>
.pipeline-form {
  padding: 0 24px 32px;
}

.form-checkbox {
  margin-bottom: 16px;
}

.select-item {
  margin-bottom: 16px;
}
</style>
